module.exports = __webpack_public_path__ + "media/newstyle/images/stars_2-orange-81836d09eb3dfc954a1a063f35ff2956.svg";